import { RoutedAppErrorPage } from "@/components/common/pages/error-screen";
import { appErrorSearchSchema } from "@/lib/app-error-routes";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/errors/404")({
  component: RouteComponent,
  validateSearch: appErrorSearchSchema,
});

function RouteComponent() {
  const { from } = Route.useSearch();

  return <RoutedAppErrorPage type="404" from={from} />;
}
